import { Component, Input, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';

import { PurchaseOrderLineDetails, PurchaseOrderLineService, PurchaseOrderProcesses, SummaryItem } from 'tms-lib';

@Component({
  selector: 'app-purchase-order-line-modal',
  templateUrl: './purchase-order-line-modal.component.html',
  styleUrl: './purchase-order-line-modal.component.scss',
})
export class PurchaseOrderLineModalComponent implements OnInit {
  @Input() purchaseOrderLineId: string;
  @Input() purchaseOrderHeaderId: string;
  @Input() purchaseOrderProcess: string;
  @Input() supplierId: string;
  @Input() productId: string;
  @Input() model: PurchaseOrderLineDetails;
  @Input() lineSequence: number;
  @Input() quantity: number;

  @Output() commentStart = $localize`Regarding Order Line `;

  readonly orderLineHeader = $localize`Order Line`;
  readonly salesOrderAllocationHeader = $localize`Sales Order Allocation`;
  readonly purchaseOrderAllocationHeader = $localize`Purchase Order Allocation`;
  readonly purchaseOrderReceiptsHeader = $localize`Receipts`;
  readonly processingHeader = $localize`Processing`;
  readonly commentsHeader = $localize`Comments`;
  readonly PurchaseOrderProcesses = PurchaseOrderProcesses;

  model$: Observable<PurchaseOrderLineDetails>;

  constructor(public purchaseOrderLineService: PurchaseOrderLineService) {}

  ngOnInit() {
    if (this.purchaseOrderHeaderId || this.purchaseOrderLineId) {
      this.model$ = this.purchaseOrderLineId
        ? this.purchaseOrderLineService.edit(this.purchaseOrderLineId)
        : this.purchaseOrderLineService.create(this.purchaseOrderHeaderId);
    }
    this.commentStart += this.lineSequence;
  }

  summaryTopItems(model: PurchaseOrderLineDetails): SummaryItem[] {
    return [
      { label: $localize`Order Number`, value: model.purchaseOrderAndLineNo },
      { label: $localize`Supplier`, value: model.supplierKey },
      { label: $localize`Name`, value: model.supplierName },
    ];
  }
}
